import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import tt from '@tomtom-international/web-sdk-maps'
import '@tomtom-international/web-sdk-maps/dist/maps.css'
import { Fieldset } from 'primereact/fieldset'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'

import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  Btn,
  CustomCalendar,
  CustomCheckbox,
  CustomMultiSelect,
  CustomPanel,
  CustomTriStateCheckbox,
  NumeroDecimal,
  PageHeader,
} from '../../../../../components'
import { laranja } from '../../../../../assets/js/colors'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import { CONFIG } from '../../../../../config'
import ligthStreetDrivingStyle from '../../../../../assets/map-styles/ligth-street-driving.json'
import { useRoteirizacaoAutomaticaHook, getVehicleColor } from './RoteirizacaoAutomaticaHook'
import ModalCliente from '../../../Cadastros/Cliente/ModalCliente/ModalCliente'
import { getClientByDeliveryId } from '../../../../../services/api/https/registration/client.http'

function getScrollParent(node) {
  if (!node || node === document.body) return document.documentElement
  var style = window.getComputedStyle(node)
  var overflow = style.overflow + style.overflowY
  if (overflow.indexOf('auto') !== -1 || overflow.indexOf('scroll') !== -1) return node
  return getScrollParent(node.parentElement)
}

function fmtNum(value, decimals) {
  return Number(value).toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

function OccupancyBar({ label, used, capacity }) {
  const pct = capacity > 0 ? Math.min(100, (used / capacity) * 100) : 0
  const barColor = pct >= 90 ? '#ef4444' : pct >= 70 ? '#f59e0b' : '#10b981'
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.78rem', marginBottom: 4 }}>
      <span style={{ width: 72, color: '#9ca3af', flexShrink: 0 }}>{label}</span>
      <div style={{ flex: 1, background: '#e5e7eb', borderRadius: 9999, height: 7, overflow: 'hidden' }}>
        <div style={{ background: barColor, height: 7, borderRadius: 9999, width: pct + '%' }} />
      </div>
      <span style={{ minWidth: 160, textAlign: 'right', color: '#6b7280', flexShrink: 0, whiteSpace: 'nowrap' }}>
        {fmtNum(used, 2)} / {fmtNum(capacity, 2)}{' '}
        <span style={{ color: '#9ca3af' }}>({fmtNum(Math.floor(pct), 0)}%)</span>
      </span>
    </div>
  )
}

const { ENVIROMENT } = CONFIG
const TOMTOM_API_KEY = CONFIG[ENVIROMENT]['TOMTOM_API_KEY']

function RoteirizacaoAutomatica({ history, selectedTp, dispatch }) {
  const {
    vehicles,
    entregas,
    dataPrevista,
    setDataPrevista,
    selectedVehicleIds,
    setSelectedVehicleIds,
    selectedStepIds,
    selecionarTodas,
    simulationResult,
    simulationOutdated,
    markSimulationOutdated,
    updateEntregaCoords,
    isSimulating,
    isSaving,
    onSimular,
    onSalvar,
    onToggleEntrega,
    onSelecionarTodas,
    vehicleOptions,
  } = useRoteirizacaoAutomaticaHook({ history, selectedTp, dispatch })

  const [filterText, setFilterText] = useState('')
  const [filtrarReentregas, setFiltrarReentregas] = useState(false)
  const [selectedRouteVehicleId, setSelectedRouteVehicleId] = useState(null)
  const [expandedVehicleIds, setExpandedVehicleIds] = useState([])
  const [unassignedExpanded, setUnassignedExpanded] = useState(false)
  const [mapFullscreen, setMapFullscreen] = useState(false)
  const [mapFading, setMapFading] = useState(false)
  const [showUnassigned, setShowUnassigned] = useState(true)
  const [reviewDeliveryId, setReviewDeliveryId] = useState(null)
  const [reviewClientData, setReviewClientData] = useState(null)

  useEffect(() => {
    setExpandedVehicleIds([])
    setUnassignedExpanded(false)
  }, [simulationResult])

  useEffect(() => {
    if (!reviewDeliveryId) return
    dispatch(showLoadingBox('Carregando dados do cliente...'))
    getClientByDeliveryId(reviewDeliveryId)
      .then(data => setReviewClientData(data))
      .catch(() => dispatch(showMessageBox(null, 'Não foi possível carregar os dados do cliente.')))
      .finally(() => dispatch(hideLoadingBox()))
  }, [reviewDeliveryId])

  const normalize = str =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')

  const filteredEntregas = entregas.filter(e => {
    if (filtrarReentregas && e.status_id !== 12) return false
    if (!filterText) return true
    const t = normalize(filterText)
    return (
      (e.identifier && normalize(e.identifier).indexOf(t) !== -1) ||
      (e.nome_fantasia && normalize(e.nome_fantasia).indexOf(t) !== -1) ||
      (e.company_name && normalize(e.company_name).indexOf(t) !== -1) ||
      (e.city && normalize(e.city).indexOf(t) !== -1)
    )
  })

  const mapRef = useRef(null)
  const mapInstanceRef = useRef(null)
  const markersRef = useRef({})
  const topRef = useRef(null)
  const bottomRef = useRef(null)
  const savedScrollRef = useRef(0)
  const reviewClickRef = useRef(null)

  useEffect(() => {
    if (simulationResult) {
      const timer = setTimeout(() => initMap(), 150)
      return () => clearTimeout(timer)
    }
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove()
        mapInstanceRef.current = null
      }
    }
  }, [simulationResult])

  useEffect(() => {
    if (!mapInstanceRef.current) return
    var timer = setTimeout(function() {
      if (mapInstanceRef.current) mapInstanceRef.current.resize()
    }, 50)
    return function() { clearTimeout(timer) }
  }, [mapFullscreen])

  useEffect(() => {
    if (mapFullscreen) return
    var scrollable = getScrollParent(topRef.current)
    if (!scrollable) return
    var saved = savedScrollRef.current
    var timer = setTimeout(function() { scrollable.scrollTop = saved }, 0)
    return function() { clearTimeout(timer) }
  }, [mapFullscreen])

  useEffect(() => {
    const map = mapInstanceRef.current
    if (!map || !simulationResult) return
    simulationResult.routes.forEach(route => {
      const show = selectedRouteVehicleId !== 'none' && (selectedRouteVehicleId === null || selectedRouteVehicleId === route.vehicle_id)
      const layerId = 'layer-' + route.vehicle_id
      if (map.getLayer(layerId)) {
        map.setLayoutProperty(layerId, 'visibility', show ? 'visible' : 'none')
      }
      var markers = markersRef.current[route.vehicle_id] || []
      markers.forEach(function(m) { m.getElement().style.display = show ? 'flex' : 'none' })
    })
    var unassignedMarkers = markersRef.current['unassigned'] || []
    unassignedMarkers.forEach(function(m) { m.getElement().style.display = showUnassigned ? 'flex' : 'none' })
  }, [selectedRouteVehicleId, showUnassigned])

  const initMap = () => {
    if (!mapRef.current) return
    if (mapInstanceRef.current) {
      mapInstanceRef.current.remove()
      mapInstanceRef.current = null
    }
    markersRef.current = {}
    if (reviewClickRef.current) mapRef.current.removeEventListener('click', reviewClickRef.current)
    reviewClickRef.current = function(e) {
      var el = e.target
      while (el && !el.getAttribute('data-review-id')) el = el.parentElement
      if (!el) return
      setReviewDeliveryId(parseInt(el.getAttribute('data-review-id'), 10))
    }
    mapRef.current.addEventListener('click', reviewClickRef.current)

    const tpCoords = simulationResult.tp_coords
    const center =
      tpCoords && tpCoords.longitude && tpCoords.latitude
        ? [parseFloat(tpCoords.longitude), parseFloat(tpCoords.latitude)]
        : [-46.6333, -23.5505]

    const map = tt.map({
      key: TOMTOM_API_KEY,
      container: mapRef.current,
      center,
      zoom: 11,
      style: ligthStreetDrivingStyle,
    })
    mapInstanceRef.current = map

    map.on('load', () => {
      if (tpCoords && tpCoords.longitude && tpCoords.latitude) {
        const depotEl = document.createElement('div')
        depotEl.style.cssText =
          'width:34px;height:34px;border-radius:50%;background:#222;color:#fff;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:bold;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.4);'
        depotEl.textContent = 'TP'
        new tt.Marker({ element: depotEl })
          .setLngLat([parseFloat(tpCoords.longitude), parseFloat(tpCoords.latitude)])
          .setPopup(new tt.Popup({ anchor: 'top' }).setHTML(
            '<b>' + (tpCoords.name || 'Operador Logístico') + '</b>' +
            (tpCoords.address
              ? '<br/><span style="color:#6b7280;font-size:0.85em">' +
                tpCoords.address +
                (tpCoords.number ? ', ' + tpCoords.number : '') +
                (tpCoords.district ? ' - ' + tpCoords.district : '') +
                (tpCoords.city ? ', ' + tpCoords.city + (tpCoords.uf ? '/' + tpCoords.uf : '') : '') +
                '</span>'
              : (tpCoords.city ? '<br/><span style="color:#6b7280;font-size:0.85em">' + tpCoords.city + (tpCoords.uf ? '/' + tpCoords.uf : '') + '</span>' : ''))
          ))
          .addTo(map)
      }

      simulationResult.routes.forEach((route, idx) => {
        const color = getVehicleColor(idx)

        // Um marcador por parada (cliente), popup lista todas as entregas
        route.stops.forEach((stop, i) => {
          const stopEntregas = stop.step_ids
            .map(sid => entregas.find(e => e.step_id === sid))
            .filter(Boolean)
          const first = stopEntregas[0]
          if (!first || !first.latitude || !first.longitude) return
          const el = document.createElement('div')
          el.style.cssText =
            'width:26px;height:26px;border-radius:50%;background:' +
            color +
            ';color:#fff;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:bold;border:2px solid #fff;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.3);'
          el.textContent = String(i + 1)
          const stopWeight = stop.steps.reduce(function(s, st) { return s + (st.weight_kg || 0) }, 0)
          const stopVolume = stop.steps.reduce(function(s, st) { return s + (st.volume_m3 || 0) }, 0)
          const popupHtml =
            '<b>' + (first.nome_fantasia || first.company_name || '') + '</b>' +
            '<br/><span style="color:#6b7280;font-size:0.85em">' + (first.address ? first.address + (first.number ? ', ' + first.number : '') + (first.district ? ' - ' + first.district : '') + (first.city ? ', ' + first.city + (first.uf ? '/' + first.uf : '') : '') : (first.city ? first.city + (first.uf ? '/' + first.uf : '') : '')) + (stopWeight > 0 ? ' · ' + fmtNum(stopWeight, 2) + ' kg' : '') + (stopVolume > 0 ? ' · ' + fmtNum(stopVolume, 3) + ' m³' : '') + '</span>' +
            (first.company_name ? '<br/><span style="color:#6b7280;font-size:0.85em">' + first.company_name + '</span>' : '') +
            stop.steps.map(function(st) {
              var line = '<br/>· ' + st.identifier
              var hasW = st.weight_kg > 0, hasV = st.volume_m3 > 0
              if (hasW || hasV) {
                line += ' (' + (hasW ? fmtNum(st.weight_kg, 2) + ' kg' : '') + (hasW && hasV ? ' · ' : '') + (hasV ? fmtNum(st.volume_m3, 3) + ' m³' : '') + ')'
              }
              return line
            }).join('') +
            (first.delivery_id ? '<br/><button data-review-id="' + first.delivery_id + '" style="margin-top:6px;padding:0;font-size:0.8em;color:#4f46e5;background:none;border:none;cursor:pointer;text-decoration:underline;">Revisar Coordenadas</button>' : '')
          var marker = new tt.Marker({ element: el })
            .setLngLat([parseFloat(first.longitude), parseFloat(first.latitude)])
            .setPopup(new tt.Popup({ anchor: 'top' }).setHTML(popupHtml))
            .addTo(map)
          if (!markersRef.current[route.vehicle_id]) markersRef.current[route.vehicle_id] = []
          markersRef.current[route.vehicle_id].push(marker)
        })

        // Linha da rota: TP → paradas ordenadas → TP
        const stopCoords = route.stops
          .map(stop => {
            const first = stop.step_ids
              .map(sid => entregas.find(e => e.step_id === sid))
              .filter(Boolean)[0]
            return first && first.latitude && first.longitude
              ? [parseFloat(first.longitude), parseFloat(first.latitude)]
              : null
          })
          .filter(Boolean)

        if (stopCoords.length > 0 && tpCoords && tpCoords.longitude && tpCoords.latitude) {
          const tpLng = parseFloat(tpCoords.longitude)
          const tpLat = parseFloat(tpCoords.latitude)
          const coords = [[tpLng, tpLat]].concat(stopCoords).concat([[tpLng, tpLat]])
          const sourceId = 'route-' + route.vehicle_id
          map.addSource(sourceId, {
            type: 'geojson',
            data: { type: 'Feature', geometry: { type: 'LineString', coordinates: coords } },
          })
          map.addLayer({
            id: 'layer-' + route.vehicle_id,
            type: 'line',
            source: sourceId,
            paint: { 'line-color': color, 'line-width': 3, 'line-opacity': 0.75 },
          })
        }
      })

      // Marcadores de entregas não atribuídas
      simulationResult.unassigned.forEach(function(u) {
        var ent = entregas.find(function(e) { return e.step_id === u.step_id })
        if (!ent || !ent.latitude || !ent.longitude) return
        var el = document.createElement('div')
        el.style.cssText =
          'width:26px;height:26px;border-radius:50%;background:#b45309;color:#fff;' +
          'display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:bold;' +
          'border:2px solid #fff;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.3);'
        el.textContent = '!'
        if (!showUnassigned) el.style.display = 'none'
        var popupHtml =
          '<b>' + (ent.nome_fantasia || ent.company_name || u.identifier) + '</b>' +
          '<br/><span style="color:#6b7280;font-size:0.85em">' + (ent.address ? ent.address + (ent.number ? ', ' + ent.number : '') + (ent.district ? ' - ' + ent.district : '') + (ent.city ? ', ' + ent.city + (ent.uf ? '/' + ent.uf : '') : '') : (ent.city ? ent.city + (ent.uf ? '/' + ent.uf : '') : '')) + (u.weight_kg > 0 ? ' · ' + fmtNum(u.weight_kg, 2) + ' kg' : '') + (u.volume_m3 > 0 ? ' · ' + fmtNum(u.volume_m3, 3) + ' m³' : '') + '</span>' +
          (ent.company_name ? '<br/><span style="color:#6b7280;font-size:0.85em">' + ent.company_name + '</span>' : '') +
          '<br/>· ' + u.identifier + (u.weight_kg > 0 || u.volume_m3 > 0 ? ' (' + (u.weight_kg > 0 ? fmtNum(u.weight_kg, 2) + ' kg' : '') + (u.weight_kg > 0 && u.volume_m3 > 0 ? ' · ' : '') + (u.volume_m3 > 0 ? fmtNum(u.volume_m3, 3) + ' m³' : '') + ')' : '') +
          '<br/><span style="color:#b45309;font-size:0.85em">↳ ' + u.reason + '</span>' +
          (ent.delivery_id ? '<br/><button data-review-id="' + ent.delivery_id + '" style="margin-top:6px;padding:0;font-size:0.8em;color:#4f46e5;background:none;border:none;cursor:pointer;text-decoration:underline;">Revisar Coordenadas</button>' : '')
        var marker = new tt.Marker({ element: el })
          .setLngLat([parseFloat(ent.longitude), parseFloat(ent.latitude)])
          .setPopup(new tt.Popup({ anchor: 'top' }).setHTML(popupHtml))
          .addTo(map)
        if (!markersRef.current['unassigned']) markersRef.current['unassigned'] = []
        markersRef.current['unassigned'].push(marker)
      })

      const allCoords = []
      if (tpCoords && tpCoords.longitude && tpCoords.latitude) {
        allCoords.push([parseFloat(tpCoords.longitude), parseFloat(tpCoords.latitude)])
      }
      simulationResult.routes.forEach(route => {
        route.stops.forEach(stop => {
          const first = stop.step_ids
            .map(sid => entregas.find(e => e.step_id === sid))
            .filter(Boolean)[0]
          if (first && first.latitude && first.longitude) {
            allCoords.push([parseFloat(first.longitude), parseFloat(first.latitude)])
          }
        })
      })
      simulationResult.unassigned.forEach(function(u) {
        var ent = entregas.find(function(e) { return e.step_id === u.step_id })
        if (ent && ent.latitude && ent.longitude) {
          allCoords.push([parseFloat(ent.longitude), parseFloat(ent.latitude)])
        }
      })
      if (allCoords.length > 1) {
        const lngs = allCoords.map(c => c[0])
        const lats = allCoords.map(c => c[1])
        map.fitBounds(
          [[Math.min.apply(null, lngs), Math.min.apply(null, lats)], [Math.max.apply(null, lngs), Math.max.apply(null, lats)]],
          { padding: 60, maxZoom: 14 },
        )
      }

      // Aplica filtro de veículo já selecionado no momento em que o mapa carrega
      if (selectedRouteVehicleId !== null) {
        simulationResult.routes.forEach(route => {
          const show = route.vehicle_id === selectedRouteVehicleId
          const layerId = 'layer-' + route.vehicle_id
          if (map.getLayer(layerId)) {
            map.setLayoutProperty(layerId, 'visibility', show ? 'visible' : 'none')
          }
          var routeMarkers = markersRef.current[route.vehicle_id] || []
          routeMarkers.forEach(function(m) { m.getElement().style.display = show ? 'flex' : 'none' })
        })
      }
    })
  }

  const farolTemplate = rowData => {
    const isReentrega = rowData.status_id === 12
    return (
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          backgroundColor: isReentrega ? laranja : null,
          margin: '0 auto',
        }}
      />
    )
  }

  const vehicleFilterBar = simulationResult ? (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <span style={{ fontSize: '0.78rem', color: '#9ca3af', marginRight: 2 }}>Veículo:</span>
      <button
        onClick={() => setSelectedRouteVehicleId(null)}
        style={{
          padding: '3px 12px', borderRadius: 9999, cursor: 'pointer',
          fontSize: '0.78rem', fontWeight: selectedRouteVehicleId === null ? 600 : 400,
          background: selectedRouteVehicleId === null ? '#4f46e5' : '#fff',
          color: selectedRouteVehicleId === null ? '#fff' : '#4b5563',
          border: '1px solid ' + (selectedRouteVehicleId === null ? '#4f46e5' : '#d1d5db'),
        }}
      >
        Todos
      </button>
      {simulationResult.routes.map((route, idx) => {
        const color = getVehicleColor(idx)
        const isActive = selectedRouteVehicleId === route.vehicle_id
        return (
          <button
            key={route.vehicle_id}
            onClick={() => setSelectedRouteVehicleId(route.vehicle_id)}
            style={{
              padding: '3px 12px', borderRadius: 9999, cursor: 'pointer',
              fontSize: '0.78rem', fontWeight: isActive ? 600 : 400,
              background: isActive ? color : '#fff',
              color: isActive ? '#fff' : '#4b5563',
              border: '1px solid ' + (isActive ? color : '#d1d5db'),
              display: 'flex', alignItems: 'center', gap: 6,
            }}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: isActive ? '#fff' : color, flexShrink: 0 }} />
            {route.vehicle_badge}
          </button>
        )
      })}
      <button
        onClick={() => setSelectedRouteVehicleId('none')}
        style={{
          padding: '3px 12px', borderRadius: 9999, cursor: 'pointer',
          fontSize: '0.78rem', fontWeight: selectedRouteVehicleId === 'none' ? 600 : 400,
          background: selectedRouteVehicleId === 'none' ? '#6b7280' : '#fff',
          color: selectedRouteVehicleId === 'none' ? '#fff' : '#4b5563',
          border: '1px solid ' + (selectedRouteVehicleId === 'none' ? '#6b7280' : '#d1d5db'),
        }}
      >
        Nenhum
      </button>
      {simulationResult.unassigned.length > 0 && (
        <button
          onClick={() => setShowUnassigned(function(v) { return !v })}
          style={{
            padding: '3px 12px', borderRadius: 9999, cursor: 'pointer',
            fontSize: '0.78rem',
            fontWeight: showUnassigned ? 600 : 400,
            background: showUnassigned ? '#b45309' : '#fff',
            color: showUnassigned ? '#fff' : '#4b5563',
            border: '1px solid ' + (showUnassigned ? '#b45309' : '#d1d5db'),
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: showUnassigned ? '#fff' : '#b45309', flexShrink: 0 }} />
          Não Atribuídas
        </button>
      )}
    </div>
  ) : null

  return (
    <>
      <div ref={topRef} />
      <PageHeader>3.4 - Roteirização Automática</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <Fieldset legend="Configuração da Roteirização">
            <div className="p-grid" style={{ alignItems: 'flex-end' }}>
              <div className="p-col-2">
                <CustomCalendar
                  label="Data Prevista de Entrega"
                  value={dataPrevista}
                  onChange={setDataPrevista}
                />
              </div>
              <div className="p-col-3">
                <CustomMultiSelect
                  label="Veículos"
                  options={vehicleOptions}
                  value={selectedVehicleIds}
                  onChange={setSelectedVehicleIds}
                />
              </div>
              <div className="p-col-7" style={{ paddingTop: 22 }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
                  <Btn onClick={onSimular} disabled={isSimulating}>
                    {isSimulating ? 'Calculando...' : 'Simular'}
                  </Btn>
                  <Btn onClick={onSalvar} disabled={isSaving || !simulationResult || simulationOutdated}>
                    Salvar Carregamento
                  </Btn>
                  {simulationOutdated && (
                    <span style={{ fontSize: '0.72rem', color: '#dc2626', whiteSpace: 'nowrap' }}>
                      Simule novamente para salvar.
                    </span>
                  )}
                </div>
              </div>
            </div>
          </Fieldset>

          <Fieldset
            legend={`Entregas (${selectedStepIds.length} de ${entregas.length} selecionadas${filteredEntregas.length !== entregas.length ? ' · ' + filteredEntregas.length + ' exibidas' : ''})`}
            style={{ marginTop: 12 }}
          >
            <div className="p-grid" style={{ alignItems: 'center', marginBottom: 8 }}>
              <div className="p-col-5">
                <InputText
                  value={filterText}
                  onChange={e => setFilterText(e.target.value)}
                  placeholder="Filtrar por identificador, empresa, cidade..."
                  style={{ width: '100%' }}
                />
              </div>
              <div className="p-col-3" style={{ paddingLeft: 16 }}>
                <CustomCheckbox
                  checked={filtrarReentregas}
                  onChange={() => setFiltrarReentregas(!filtrarReentregas)}
                >
                  Apenas Reentregas
                </CustomCheckbox>
              </div>
              <div className="p-col-4" style={{ paddingLeft: 16 }}>
                <CustomCheckbox
                  checked={selecionarTodas}
                  onChange={() => onSelecionarTodas(!selecionarTodas, filteredEntregas)}
                >
                  Selecionar Todas ({filteredEntregas.length})
                </CustomCheckbox>
              </div>
            </div>
            <DataTable
              value={filteredEntregas}
              rows={10}
              paginator
              rowsPerPageOptions={[10, 25, 50]}
            >
              <Column
                style={tableCellCentered(50)}
                body={entrega => (
                  <CustomTriStateCheckbox
                    value={selectedStepIds.includes(entrega.step_id)}
                    onClick={() => onToggleEntrega(entrega)}
                  />
                )}
              />
              <Column field="identifier" header="Identificador" sortable headerStyle={{ whiteSpace: 'nowrap' }} />
              <Column field="nome_fantasia" header="Nome Fantasia" sortable headerStyle={{ whiteSpace: 'nowrap' }} />
              <Column field="company_name" header="Empresa" style={tableCellCentered()} sortable headerStyle={{ whiteSpace: 'nowrap' }} />
              <Column field="city" header="Cidade" style={tableCellCentered(130)} sortable headerStyle={{ whiteSpace: 'nowrap' }} />
              <Column
                field="weight"
                header="Peso (Kg)"
                style={tableCellCentered(90)}
                sortable
                headerStyle={{ whiteSpace: 'nowrap' }}
                body={({ weight }) => <NumeroDecimal decimalScale={2}>{weight}</NumeroDecimal>}
              />
              <Column
                field="status_id"
                header="Status"
                style={tableCellCentered(60)}
                body={farolTemplate}
              />
            </DataTable>
          </Fieldset>

          {simulationResult && (() => {
            const totalStops = simulationResult.routes.reduce((sum, r) => sum + r.stats.stops, 0)
            const totalDistM = simulationResult.routes.reduce((sum, r) => sum + r.stats.total_distance_m, 0)
            const totalWeightKg = simulationResult.routes.reduce((sum, r) => sum + r.stats.total_weight_kg, 0)
            const totalVolumeM3 = simulationResult.routes.reduce((sum, r) => sum + r.stats.total_volume_m3, 0)
            const visible = selectedRouteVehicleId === null
              ? simulationResult.routes
              : simulationResult.routes.filter(r => r.vehicle_id === selectedRouteVehicleId)
            const displayRoutes = visible.length > 0 ? visible : simulationResult.routes

            const collapseHeaderStyle = {
              display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer',
              userSelect: 'none', padding: '6px 0',
            }
            const chevron = isOpen => (
              <span style={{ marginLeft: 'auto', fontSize: '0.7rem', color: '#9ca3af' }}>
                {isOpen ? '▲' : '▼'}
              </span>
            )

            return (
              <>
                <Fieldset legend="Resultado da Simulação" style={{ marginTop: 16 }}>
                  {/* Resumo geral */}
                  <div style={{ display: 'flex', gap: 20, marginBottom: 16, fontSize: '0.88rem', color: '#4b5563', flexWrap: 'wrap', alignItems: 'center' }}>
                    <span><b>{simulationResult.routes.length}</b> rota{simulationResult.routes.length !== 1 ? 's' : ''}</span>
                    <span style={{ color: '#d1d5db' }}>·</span>
                    <span><b>{totalStops}</b> parada{totalStops !== 1 ? 's' : ''}</span>
                    <span style={{ color: '#d1d5db' }}>·</span>
                    <span><b>{fmtNum(totalDistM / 1000, 1)}</b> km</span>
                    <span style={{ color: '#d1d5db' }}>·</span>
                    <span><b>{fmtNum(totalWeightKg, 1)}</b> kg</span>
                    {totalVolumeM3 > 0 && (
                      <>
                        <span style={{ color: '#d1d5db' }}>·</span>
                        <span><b>{fmtNum(totalVolumeM3, 3)}</b> m³</span>
                      </>
                    )}
                  </div>

                  {/* Seletor de veículo */}
                  <div style={{ marginBottom: 16 }}>{vehicleFilterBar}</div>

                  {/* Entregas não atribuídas — colapsável */}
                  {simulationResult.unassigned.length > 0 && (
                    <div style={{ marginBottom: 20, borderLeft: '3px solid #b45309', paddingLeft: 12 }}>
                      <div
                        style={collapseHeaderStyle}
                        onClick={() => setUnassignedExpanded(!unassignedExpanded)}
                      >
                        <span style={{
                          width: 20, height: 20, borderRadius: '50%', background: '#b45309',
                          color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: '0.72rem', fontWeight: 700, flexShrink: 0,
                        }}>!</span>
                        <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#b45309' }}>
                          {simulationResult.unassigned.length} entrega{simulationResult.unassigned.length !== 1 ? 's' : ''} não atribuída{simulationResult.unassigned.length !== 1 ? 's' : ''}
                        </span>
                        {chevron(unassignedExpanded)}
                      </div>
                      {unassignedExpanded && (
                        <ul style={{ margin: '8px 0 0 0', padding: 0, listStyle: 'none' }}>
                          {(function() {
                            var groups = []
                            var seen = {}
                            simulationResult.unassigned.forEach(function(u) {
                              var e = entregas.find(function(en) { return en.step_id === u.step_id })
                              var key = e ? String(e.client_id) : ('_' + u.step_id)
                              if (!seen[key]) {
                                seen[key] = { e: e, items: [] }
                                groups.push(seen[key])
                              }
                              seen[key].items.push(u)
                            })
                            return groups.map(function(group) {
                              var e = group.e
                              var items = group.items
                              var totalWeight = items.reduce(function(s, u) { return s + (u.weight_kg || 0) }, 0)
                              var totalVolume = items.reduce(function(s, u) { return s + (u.volume_m3 || 0) }, 0)
                              var clientKey = e ? e.client_id : items[0].step_id
                              return (
                                <li key={clientKey} style={{ display: 'flex', gap: 10, marginBottom: 10, alignItems: 'flex-start' }}>
                                  <div>
                                    <div style={{ fontWeight: 600, fontSize: '0.87rem' }}>
                                      {e ? (e.nome_fantasia || e.company_name || items[0].identifier) : items[0].identifier}
                                    </div>
                                    <div style={{ fontSize: '0.77rem', color: '#6b7280' }}>
                                      {e && e.address && (
                                        e.address +
                                        (e.number ? ', ' + e.number : '') +
                                        (e.district ? ' - ' + e.district : '') +
                                        (e.city ? ', ' + e.city + (e.uf ? '/' + e.uf : '') : '')
                                      )}
                                      {e && !e.address && e.city && (e.city + (e.uf ? '/' + e.uf : ''))}
                                      {totalWeight > 0 ? ' · ' + fmtNum(totalWeight, 2) + ' kg' : ''}
                                      {totalVolume > 0 ? ' · ' + fmtNum(totalVolume, 3) + ' m³' : ''}
                                    </div>
                                    {e && e.company_name && (
                                      <div style={{ fontSize: '0.72rem', color: '#6b7280' }}>{e.company_name}</div>
                                    )}
                                    {items.map(function(u) {
                                      return (
                                        <div key={u.step_id}>
                                          <div style={{ fontSize: '0.77rem', color: '#374151', marginTop: 2 }}>
                                            {'· ' + u.identifier}
                                            {u.weight_kg > 0 ? ' (' + fmtNum(u.weight_kg, 2) + ' kg' : ''}
                                            {u.volume_m3 > 0
                                              ? (u.weight_kg > 0 ? ' · ' : ' (') + fmtNum(u.volume_m3, 3) + ' m³)'
                                              : (u.weight_kg > 0 ? ')' : '')}
                                          </div>
                                          <div style={{ fontSize: '0.77rem', color: '#b45309', marginTop: 1 }}>↳ {u.reason}</div>
                                        </div>
                                      )
                                    })}
                                    {e && e.delivery_id && (
                                      <button
                                        onClick={() => setReviewDeliveryId(e.delivery_id)}
                                        style={{
                                          marginTop: 4, padding: '1px 8px', fontSize: '0.72rem',
                                          color: '#4f46e5', background: 'none', border: 'none',
                                          cursor: 'pointer', textDecoration: 'underline', paddingLeft: 0,
                                        }}
                                      >
                                        Revisar Coordenadas
                                      </button>
                                    )}
                                  </div>
                                </li>
                              )
                            })
                          })()}
                        </ul>
                      )}
                    </div>
                  )}

                  {/* Detalhes por veículo — cada um colapsável */}
                  {displayRoutes.map(route => {
                    const globalIdx = simulationResult.routes.indexOf(route)
                    const color = getVehicleColor(globalIdx)
                    const vehicle = vehicles.find(v => v.id === route.vehicle_id)
                    const capKg = vehicle ? (vehicle.capacity_kg || 0) : 0
                    const capM3 = vehicle ? (vehicle.capacity_m3 || 0) : 0
                    const isExpanded = expandedVehicleIds.indexOf(route.vehicle_id) !== -1
                    const toggleExpand = () => setExpandedVehicleIds(prev =>
                      prev.indexOf(route.vehicle_id) !== -1
                        ? prev.filter(id => id !== route.vehicle_id)
                        : prev.concat(route.vehicle_id)
                    )
                    return (
                      <div key={route.vehicle_id} style={{ marginBottom: 12, borderLeft: '3px solid ' + color, paddingLeft: 14 }}>
                        {/* Cabeçalho clicável */}
                        <div style={collapseHeaderStyle} onClick={toggleExpand}>
                          <span style={{ fontWeight: 700, color, fontSize: '0.95rem' }}>{route.vehicle_badge}</span>
                          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{route.stats.stops} parada{route.stats.stops !== 1 ? 's' : ''}</span>
                          <span style={{ color: '#d1d5db' }}>·</span>
                          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{fmtNum(route.stats.total_distance_m / 1000, 1)} km</span>
                          <span style={{ color: '#d1d5db' }}>·</span>
                          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{fmtNum(route.stats.total_weight_kg, 2)} kg</span>
                          {route.stats.total_volume_m3 > 0 && (
                            <>
                              <span style={{ color: '#d1d5db' }}>·</span>
                              <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{fmtNum(route.stats.total_volume_m3, 3)} m³</span>
                            </>
                          )}
                          {chevron(isExpanded)}
                        </div>

                        {/* Conteúdo colapsável */}
                        {isExpanded && (
                          <div style={{ paddingTop: 6, paddingBottom: 8 }}>
                            {capKg > 0 && (
                              <OccupancyBar label="Peso (kg)" used={route.stats.total_weight_kg} capacity={capKg} />
                            )}
                            {capM3 > 0 && (
                              <OccupancyBar label="Volume (m³)" used={route.stats.total_volume_m3} capacity={capM3} />
                            )}

                            <ul style={{ margin: '12px 0 0 0', padding: 0, listStyle: 'none' }}>
                              {route.stops.map((stop, i) => {
                                const firstEntrega = stop.step_ids
                                  .map(sid => entregas.find(en => en.step_id === sid))
                                  .filter(Boolean)[0]
                                if (!firstEntrega) return null
                                const stopWeight = stop.steps.reduce((s, st) => s + st.weight_kg, 0)
                                const stopVolume = stop.steps.reduce((s, st) => s + st.volume_m3, 0)
                                return (
                                  <li key={stop.client_id} style={{ display: 'flex', gap: 10, marginBottom: 10, alignItems: 'flex-start' }}>
                                    <span style={{
                                      width: 22, height: 22, borderRadius: '50%', background: color,
                                      color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                      fontSize: '0.7rem', fontWeight: 700, flexShrink: 0, marginTop: 2,
                                    }}>
                                      {i + 1}
                                    </span>
                                    <div>
                                      <div style={{ fontWeight: 600, fontSize: '0.87rem' }}>
                                        {firstEntrega.nome_fantasia || firstEntrega.company_name || '—'}
                                      </div>
                                      <div style={{ fontSize: '0.77rem', color: '#6b7280', marginBottom: stop.steps.length > 1 ? 4 : 0 }}>
                                        {firstEntrega.address && (
                                          firstEntrega.address +
                                          (firstEntrega.number ? ', ' + firstEntrega.number : '') +
                                          (firstEntrega.district ? ' - ' + firstEntrega.district : '') +
                                          (firstEntrega.city ? ', ' + firstEntrega.city + (firstEntrega.uf ? '/' + firstEntrega.uf : '') : '')
                                        )}
                                        {!firstEntrega.address && firstEntrega.city && (firstEntrega.city + (firstEntrega.uf ? '/' + firstEntrega.uf : ''))}
                                        {stopWeight > 0 ? ' · ' + fmtNum(stopWeight, 2) + ' kg' : ''}
                                        {stopVolume > 0 ? ' · ' + fmtNum(stopVolume, 3) + ' m³' : ''}
                                      </div>
                                      {firstEntrega.company_name && (
                                        <div style={{ fontSize: '0.72rem', color: '#6b7280' }}>{firstEntrega.company_name}</div>
                                      )}
                                      {stop.steps.map(st => (
                                        <div key={st.step_id} style={{ fontSize: '0.77rem', color: '#374151', marginTop: 2 }}>
                                          {'· ' + st.identifier}
                                          {st.weight_kg > 0 ? ' (' + fmtNum(st.weight_kg, 2) + ' kg' : ''}
                                          {st.volume_m3 > 0
                                            ? (st.weight_kg > 0 ? ' · ' : ' (') + fmtNum(st.volume_m3, 3) + ' m³)'
                                            : (st.weight_kg > 0 ? ')' : '')}
                                        </div>
                                      ))}
                                      {firstEntrega.delivery_id && (
                                        <button
                                          onClick={() => setReviewDeliveryId(firstEntrega.delivery_id)}
                                          style={{
                                            marginTop: 4, padding: '1px 8px', fontSize: '0.72rem',
                                            color: '#4f46e5', background: 'none', border: 'none',
                                            cursor: 'pointer', textDecoration: 'underline', paddingLeft: 0,
                                          }}
                                        >
                                          Revisar Coordenadas
                                        </button>
                                      )}
                                    </div>
                                  </li>
                                )
                              })}
                            </ul>
                          </div>
                        )}
                      </div>
                    )
                  })}
                </Fieldset>

                <Fieldset legend="Mapa das Rotas" style={{ marginTop: 16 }}>
                  <div style={{ marginBottom: 12 }}>{vehicleFilterBar}</div>
                  <div style={Object.assign(mapFullscreen ? {
                    position: 'fixed', top: 0, left: 0,
                    width: '100vw', height: '100vh',
                    zIndex: 2000, background: '#fff',
                  } : { position: 'relative' }, {
                    opacity: mapFading ? 0 : 1,
                    transition: 'opacity 0.18s ease',
                  })}>
                    <div ref={mapRef} style={{ width: '100%', height: mapFullscreen ? '100vh' : 480 }} />
                    <div style={{ position: 'absolute', top: 10, right: 10, display: 'flex', flexDirection: 'column', gap: 4, zIndex: 1 }}>
                      {[
                        { label: mapFullscreen ? '✕' : '⛶', title: mapFullscreen ? 'Sair do modo tela cheia' : 'Expandir mapa', onClick: function() {
                          setMapFading(true)
                          setTimeout(function() {
                            if (!mapFullscreen) {
                              var scrollable = getScrollParent(topRef.current)
                              savedScrollRef.current = scrollable ? scrollable.scrollTop : 0
                            }
                            setMapFullscreen(function(f) { return !f })
                            setMapFading(false)
                          }, 180)
                        } },
                        { label: '+', title: 'Aproximar', onClick: function() { if (mapInstanceRef.current) mapInstanceRef.current.easeTo({ zoom: mapInstanceRef.current.getZoom() + 1, duration: 300 }) } },
                        { label: '−', title: 'Afastar', onClick: function() { if (mapInstanceRef.current) mapInstanceRef.current.easeTo({ zoom: mapInstanceRef.current.getZoom() - 1, duration: 300 }) } },
                      ].map(function(btn) {
                        return (
                          <button
                            key={btn.label}
                            title={btn.title}
                            onClick={btn.onClick}
                            style={{
                              width: 32, height: 32, borderRadius: 4,
                              background: 'rgba(255,255,255,0.9)', border: '1px solid #d1d5db',
                              cursor: 'pointer', display: 'flex', alignItems: 'center',
                              justifyContent: 'center', fontSize: 16,
                              boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                            }}
                          >
                            {btn.label}
                          </button>
                        )
                      })}
                    </div>
                  </div>
                </Fieldset>
              </>
            )
          })()}
        </CustomPanel>
      </div>

      {simulationResult && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24,
          display: 'flex', flexDirection: 'column', gap: 8,
          zIndex: 1500,
        }}>
          <button
            title="Ir para o topo"
            onClick={function() { topRef.current && topRef.current.scrollIntoView({ behavior: 'smooth' }) }}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: '#fff', border: '1px solid #d1d5db',
              cursor: 'pointer', fontSize: 14, fontWeight: 700,
              boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >▲</button>
          <button
            title="Ir para o fim"
            onClick={function() { bottomRef.current && bottomRef.current.scrollIntoView({ behavior: 'smooth' }) }}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: '#fff', border: '1px solid #d1d5db',
              cursor: 'pointer', fontSize: 14, fontWeight: 700,
              boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >▼</button>
        </div>
      )}
      <div ref={bottomRef} />

      {reviewClientData && (
        <ModalCliente
          show={true}
          selectedCliente={reviewClientData}
          selectedTp={selectedTp}
          selectedCiclo={null}
          dispatch={dispatch}
          onModalClose={() => { setReviewClientData(null); setReviewDeliveryId(null) }}
          onModalSave={function(saved) {
            if (saved && saved.id && saved.latitude && saved.longitude) {
              updateEntregaCoords(saved.id, saved.latitude, saved.longitude)
            }
            markSimulationOutdated()
            setReviewClientData(null)
            setReviewDeliveryId(null)
          }}
        />
      )}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RoteirizacaoAutomatica))
